module.exports = __webpack_public_path__ + "img/Korean_Meal_Chicken.912c508b.jpg";